import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Popover, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
import Icon from "@shared/components/Icon";
import React from "react";
import NavigationItem, { capitalizeFirstLetter, styleMenuItemLink, } from "./NavigationItem";
const styleMenuItem = {
    cursor: "pointer",
    position: "relative",
};
const styleSubMenu = {
    mt: 2,
    padding: 3,
    bgcolor: "background.paper",
};
const SubMenus = ({ subMenus, isMobile, }) => {
    return (_jsx(Stack, { spacing: 2, sx: { alignItems: "flex-start" }, children: subMenus.map((item) => {
            return (_jsx(NavigationItem, { menuItem: item, sx: {
                    position: "relative",
                    color: isMobile ? "primary.contrastText" : "text.primary",
                    fontSize: "14px",
                    fontWeight: 600,
                }, isInGroup: true }, item.id));
        }) }));
};
const NavigationGroup = ({ menuItem = {}, subMenus, ...others }) => {
    const { title } = menuItem;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isOpen = Boolean(anchorEl);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const handleClickGroup = React.useCallback((event) => {
        setAnchorEl((currentAnchor) => currentAnchor
            ? null
            : (event.target ?? event.currentTarget));
    }, []);
    const closeMenuGroup = React.useCallback(() => {
        setAnchorEl(null);
    }, []);
    return (_jsx(Box, { ...others, children: _jsxs(Box, { sx: styleMenuItem, onClick: handleClickGroup, children: [_jsxs(Stack, { spacing: 1, direction: "row", tabIndex: 0, "aria-haspopup": "true", "aria-expanded": isOpen ? "true" : undefined, "aria-controls": isOpen ? `menu-group-${menuItem.id}` : undefined, sx: {
                        alignItems: "center",
                        justifyContent: isMobile ? "flex-start" : "center",
                    }, children: [_jsx(Typography, { sx: styleMenuItemLink, variant: "subtitle1", color: "colors.lynch", component: "div", children: _jsx("span", { className: "NavigationItem-label", children: capitalizeFirstLetter(title) }) }), _jsx(Icon, { icon: "chevron-down", type: "fal", title: isOpen ? "Fermer" : "Ouvrir", style: {
                                marginLeft: 8,
                                fontSize: "1.14rem",
                                display: "flex",
                                alignItems: "center",
                                transform: `rotate(${isOpen ? 180 : 0}deg)`,
                                transition: "transform linear 200ms",
                                color: "white",
                            } })] }), isMobile ? (_jsx(Box, { id: `menu-group-${menuItem.id}`, sx: { display: isOpen ? "block" : "none", mt: 2 }, children: _jsx(SubMenus, { subMenus: subMenus, isMobile: isMobile }) })) : (_jsx(Popover, { open: isOpen, anchorEl: anchorEl, onClose: closeMenuGroup, disableScrollLock: true, hideBackdrop: true, anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    }, transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    }, slotProps: {
                        paper: {
                            id: `menu-group-${menuItem.id}`,
                            sx: styleSubMenu,
                        },
                    }, children: _jsx(SubMenus, { subMenus: subMenus, isMobile: isMobile }) }))] }) }));
};
export default NavigationGroup;
